const brandSelect = document.querySelector('.brands-select select');
const brands = document.querySelectorAll('.brands-block');

function toggleShowHide(value) {
  brands.forEach((brand) => {
    var id = brand.getAttribute('id');
    if (value === id) {
      brand.classList.remove('brands-block--hidden');
    } else {
      brand.classList.add('brands-block--hidden');
    }
  });
}

if (brandSelect && brands) {
  brandSelect.addEventListener('change', (event) => {
    event.preventDefault();
    toggleShowHide(event.target.value);
  });
}
